module.exports = __webpack_public_path__ + "assets/img/37_1030.bc1eb7e3.jpg";